import { Loader2 } from "lucide-react";
import { useEffect } from "react";

const ChatSidebar = ({
  allGroups,
  activeGroup,
  userName,
  setActiveGroup,
  handleGroupClick,
  onChatSelect,
  onRoomSelect,
  selectedChatId,
  rooms,
  isLoading,
  isConnected,
}) => {
  return (
    <div className="w-full md:w-80 bg-white border-r border-gray-200 flex flex-col h-full">
      {/* Header with tabs */}

      {/* Start New Chat */}

      {/* Chat list */}
      <div className="flex-1 overflow-y-auto">
        {!activeGroup && allGroups && allGroups.length > 0 && (
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-sm font-semibold text-gray-700 mb-2">
              Current Name: {userName}
            </h2>
            <h2 className="text-sm font-semibold text-gray-700 mb-2">
              All Groups
            </h2>
            <ul className="space-y-2">
              {allGroups.map((group) => (
                <li
                  key={group.id}
                  className="cursor-pointer hover:bg-gray-100 rounded p-2 transition"
                  onClick={() => handleGroupClick(group)}
                >
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-full bg-purple-200 text-purple-800 flex items-center justify-center font-semibold mr-2">
                      {group.emoji}
                    </div>
                    <span className="text-sm text-gray-800">{group.title}</span>
                    <span className="ml-auto bg-purple-100 text-purple-800 text-xs font-semibold px-2.5 py-0.5 rounded-full shadow-sm">
                      {group.chat_profiles.length} user
                      {group.chat_profiles.length !== 1 ? "s" : ""}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
        {activeGroup && (
          <>
            <div className="p-4 border-b border-gray-200 bg-purple-50">
              <div className="flex items-center justify-between">
                <span className="text-sm text-purple-800 font-medium">
                  {activeGroup.emoji} {activeGroup.title}
                </span>
                <button
                  onClick={() => setActiveGroup(null)}
                  className="text-xs text-purple-700 hover:underline"
                >
                  ⬅ Back
                </button>
              </div>
            </div>
            {activeGroup.chat_profiles &&
              activeGroup.chat_profiles.length > 0 &&
              activeGroup.chat_profiles.map((chat_profile) => {
                return (
                  <div
                    onClick={() => onChatSelect(chat_profile)}
                    className={`flex items-center p-4 hover:bg-gray-50 cursor-pointer border-b border-gray-100 transition-colors`}
                  >
                    {/* Chat info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex relative items-center justify-between mb-1">
                        <div className="absolute bottom-1 left-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white" />
                        <h3 className="font-semibold ml-5 text-gray-900 truncate">
                          {chat_profile.chat_name}
                        </h3>
                      </div>
                    </div>
                  </div>
                );
              })}
          </>
        )}

        {rooms.length > 0 && (
          <p className="text-lg ml-2 ">Currently Connected: </p>
        )}

        {/*
          <div className="flex items-center justify-center py-8">
            <Loader className="animate-spin mr-2" size={20} />
            <span className="text-sm text-gray-600">Loading chats...</span>
          </div>
          */}
        {rooms.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            <p className="text-sm">Galli feels quiet right now</p>
            <p className="text-xs mt-1">
              Come back soon for some fresh chatter and gupshup!
            </p>
          </div>
        ) : (
          rooms.map((room) => (
            <div
              key={room.id}
              onClick={() => onRoomSelect(room)}
              className={`flex items-center p-4 hover:bg-gray-50 cursor-pointer border-b border-gray-100 transition-colors ${
                selectedChatId === room.id
                  ? "bg-purple-50 border-purple-200"
                  : ""
              } ${!isConnected ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <div
                className={`w-3 h-3 rounded-full mr-3 flex-shrink-0 ${
                  isConnected && room.isOnline ? "bg-purple-600" : "bg-gray-400"
                }`}
              />

              <div className="relative mr-3 flex-shrink-0">
                <img
                  src={
                    room.avatar ||
                    "/placeholder.svg?height=48&width=48&query=user"
                  }
                  alt={room.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                {isConnected && room.isOnline && (
                  <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white" />
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-gray-900 truncate">
                    {room.name}
                  </h3>
                  <span className="text-xs text-gray-500 flex-shrink-0">
                    {room.lastMessageTime}
                  </span>
                </div>
                <p className="text-sm text-gray-600 truncate">
                  {room.lastMessage}
                </p>
              </div>

              {room.unreadCount > 0 && (
                <div className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 animate-pulse">
                  {room.unreadCount}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChatSidebar;
